<template>
    <div class="aboutMe d_flex center" id="about">
        <div class="inner_content d_flex align_center space_around">
            <div class="text_content">
                <h2 class="section_title" v-scroll-reveal.reset>W.H.O.A.M.I</h2>
                <p class="section_content">
                    Highly Skilled DevOps and SRE professional with over a decade of experience in development, operations, and large-scale cloud architectures. Proven ability to lead cross-functional teams, implement streamlined deployment pipelines, and build resilient infrastructure for fintech, e-commerce, and food & beverage industries.
                    <br /><br />
                    <span class="key">Languages & Frameworks:</span> PHP (Laravel), Node.js, Python, Java, Groovy, JavaScript (Vue.js, React), C#, and Go.
                    <br />
                    <span class="key">AI & Machine Learning:</span> TensorFlow, PyTorch, Keras, OpenAI APIs, Hugging Face, and Scikit-learn.
                    <br />
                    <span class="key">Databases:</span> MySQL, PostgreSQL, MongoDB, Cassandra, ChromaDB, Pinecone, Redis, Neo4j, and DynamoDB.
                    <br />
                    <span class="key">Message Queueing & Streaming:</span> RabbitMQ, Kafka, MQTT, ActiveMQ, and Google Cloud Pub/Sub.
                    <br />
                    <span class="key">Cloud & Hybrid Infrastructure:</span> AWS (EKS, ECS, Lambda, RDS), Google Cloud (GKE, Cloud Functions), Microsoft Azure (AKS, App Services), DigitalOcean, Heroku, and VMware.
                    <br />
                    <span class="key">Containerization & Orchestration:</span> Docker, Kubernetes, OpenShift, Nomad, Mesos, and Docker Swarm.
                    <br />
                    <span class="key">Infrastructure as Code (IaC):</span> Terraform (Terragrunt, Terraspace), Ansible, Chef, Puppet, and Helm.
                    <br />
                    <span class="key">CI/CD Pipelines:</span> Jenkins, GitLab CI, GitHub Actions, Travis CI, CircleCI, ArgoCD, and Tekton.
                    <br />
                    <span class="key">Monitoring & Observability:</span> Prometheus, Grafana, ELK Stack, Graylog, Jaeger, OpenTelemetry, New Relic, Datadog, and AppSignal.
                    <br />
                    <span class="key">Security & Compliance:</span> Vault, KMS (AWS, GCP), Seccomp, AppArmor, CIS benchmarks, OWASP ZAP, and Snyk.
                    <br />
                    <span class="key">Networking & Protocols:</span> REST, SOAP, GraphQL, ISO 8583, gRPC, and WebSockets.
                    <br />
                    <span class="key">Operating Systems:</span> Linux (Ubuntu, CentOS, Debian), Unix (FreeBSD, Solaris), Windows Server, and Container-Optimized OS.
                    <br />
                    <span class="key">High Availability & Disaster Recovery:</span> Multi-region failover, auto-scaling, cluster management, load balancing (NGINX, HAProxy, Traefik), and backup solutions.
                    <br />
                    <span class="key">Performance Optimization:</span> Query tuning, caching strategies (Redis, Varnish, Memcached), and application profiling tools (JProfiler, VisualVM, Pyroscope).
                    <br />
                    <span class="key">DevOps Methodologies:</span> Agile, Scrum, Kanban, GitOps, and DevSecOps.
                </p>
                <div class="linkButton">
                    <LinkButton :to="'#works'" :text="'View Works'"></LinkButton>
                </div>
            </div>

            <div class="img_section" v-scroll-reveal.reset="{ origin: 'top', delay: 500, distance: '50px' }">
                <img src="@/assets/svg/aboutme.svg" alt />
            </div>
        </div>
    </div>
</template>

<script>
import { Intersection_observer } from '@/utils/observer'
const LinkButton = () => import('@/components/LinkButton')
export default {
    components: {
        LinkButton
    },
    mounted() {
        Intersection_observer( this.handleInteract, this.$el)
    },
    methods: {
        async handleInteract(entries, observer) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    this.$store.dispatch('SET_CURRENT_SECTION', 'About')
                }
            })
        }
    }
}
</script>

<style lang="scss">
.aboutMe {
    min-height: 100vh;
    background-color: #e0f0ed;

    .inner_content {
        width: 80%;
        margin: auto;
        .text_content {
            width: 50%;
            padding: 10px 20px;
            .section_title {
                color: $secondary;
                font-size: 50px;
                margin: 0;
            }

            .section_content {
                color: $primary;
                font-size: 14px;
                width: 90%;
                line-height: 1.8em;
                max-height: 70vh;
                overflow-y: auto;
                padding-right: 10px;

                /* Custom scrollbar */
                &::-webkit-scrollbar {
                    width: 6px;
                }
                
                &::-webkit-scrollbar-track {
                    background: rgba(0, 0, 0, 0.1);
                    border-radius: 3px;
                }
                
                &::-webkit-scrollbar-thumb {
                    background: $secondary;
                    border-radius: 3px;
                }
                
                &::-webkit-scrollbar-thumb:hover {
                    background: darken($secondary, 10%);
                }

                .key {
                    color: $secondary;
                    font-weight: 900;
                }
            }
            .linkButton {
                width: 200px;
            }
        }

        .img_section {
            width: 50%;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .aboutMe {
        padding: 10px !important;
        .inner_content {
            flex-wrap: wrap-reverse;
            .text_content {
                width: 100% !important;
                .section_title {
                    font-size: 38px;
                }
                .section_content {
                    width: 100%;
                    font-size: 13px;
                    max-height: 60vh;
                    line-height: 1.6em;
                }
            }

            .img_section {
                width: 100% !important;
                display: flex;
                justify-content: center;
                img {
                    width: 90% !important;
                    height: 90% !important;
                    margin: auto;
                }
            }
        }
    }
}
</style>
